module.exports = __webpack_public_path__ + "static/CircularStd-BookItalic-6c288c984966a3d5fb6badcfaba9a16e.woff2";